export class ToolsService {
    public static validateIban(ibanSaisi: string, parametredIbanMasks: object) {
        let ibanObject: { iban: string; longueur: number } = { iban: '', longueur: 0 };
        for (let i = 0; i < ibanSaisi.length; i++) {
            ibanObject.iban = ibanObject.iban.concat(ibanSaisi.charAt(i));
            ibanObject = ToolsService.validateLastCharacter(ibanObject, parametredIbanMasks);
        }
        return ibanObject;
    }

    public static validateLastCharacter(
        ibanObject: { iban: string; longueur: number },
        parametredIbanMasks: object,
    ): { iban: string; longueur: number } {
        const value: string = ibanObject.iban;
        let result: string = ibanObject.iban;
        let ibanMask: Array<string | RegExp>;
        let longueur: number = 0;
        if (
            (value.length === 1 && !RegExp('^[a-zA-Z]').test(value)) ||
            (value.length === 2 && !RegExp('^[a-zA-Z][a-zA-Z]').test(value))
        ) {
            result = value.slice(0, value.length - 1);
        } else {
            const prefix: string = value.slice(0, 2).toUpperCase();
            longueur = parametredIbanMasks[prefix];

            if (longueur) {
                const countryMask: string = ToolsService.getCountryMask(prefix, longueur);
                ibanMask = countryMask.split(';');
                if (value.length > ibanMask.length) {
                    result = value.slice(0, value.length - 1);
                } else {
                    const indexTypedCaracter: number = value.length - 1;
                    const typedCaracter: string = value.charAt(indexTypedCaracter);
                    if (
                        ibanMask[indexTypedCaracter] === ' ' ||
                        (ibanMask[indexTypedCaracter] as string).trim() === "' '"
                    ) {
                        const regExp: RegExp = RegExp((ibanMask[indexTypedCaracter + 1] as string).trim());
                        if (regExp.test(typedCaracter)) {
                            result = value.slice(0, value.length - 1).concat(' ', typedCaracter);
                        } else {
                            result = value.slice(0, value.length - 1);
                        }
                    } else {
                        const regExp: RegExp = RegExp((ibanMask[indexTypedCaracter] as string).trim());
                        if (!regExp.test(typedCaracter)) {
                            result = value.slice(0, value.length - 1);
                        }
                    }
                }
            } else {
                result = value.slice(0, 2);
            }
        }
        ibanObject.iban = result;
        ibanObject.longueur = ibanMask ? ibanMask.length : 3;
        return ibanObject;
    }

    public static getCountryMask(country: string, longueur: number): string {
        let mask: string = '';
        if (longueur) {
            mask = `[${country.charAt(0).toLowerCase()}|${country.charAt(0).toUpperCase()}];[${country
                .charAt(1)
                .toLowerCase()}|${country.charAt(1).toUpperCase()}]`;
            for (let i = 2; i < longueur; i++) {
                mask = mask.concat(';[0-9A-Za-z]');
                if ((i === 3 || i % 4 === 3) && i < longueur - 1) {
                    mask = mask.concat(";' '");
                }
            }
        }
        return mask;
    }

    public static cleanIban(iban: string): string {
        return iban.replace(/\s/g, '').trim();
    }
}
